import { render, staticRenderFns } from "./BookedAwardsHistoryList.vue?vue&type=template&id=be94818a&"
import script from "./BookedAwardsHistoryList.vue?vue&type=script&lang=js&"
export * from "./BookedAwardsHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./BookedAwardsHistoryList.vue?vue&type=style&index=0&id=be94818a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports